/* We're explicitly defining the list of entities we want to escape.
nbsp is an HTML entity, but we don't want to escape all space characters in a string, hence its omission in this map.

*/
var escapeChars = {
    '¢' : 'cent',
    '£' : 'pound',
    '¥' : 'yen',
    '€': 'euro',
    '©' :'copy',
    '®' : 'reg',
    '<' : 'lt',
    '>' : 'gt',
    '"' : 'quot',
    '&' : 'amp',
    "'" : '#39'
};

module.exports = escapeChars;



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/helper/escapeChars.js
 ** module id = 1078
 ** module chunks = 0
 **/